import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const navLinks = [
    { label: 'Kryefaqja', href: '#hero' },
    { label: 'Rreth Nesh', href: '#about' },
    { label: 'Sherbimet', href: '#services' },
    { label: 'Galeria', href: '#gallery' },
    { label: 'Kontakti', href: '#contact' },
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    setIsOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__container">
          <a href="#hero" className="navbar__logo" onClick={(e) => handleClick(e, '#hero')}>
            <div className="navbar__logo-icon">
              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4L26 12L34 14L28 22L29 30L20 27L11 30L12 22L6 14L14 12L20 4Z"
                      stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <circle cx="20" cy="18" r="4" stroke="currentColor" strokeWidth="1"/>
              </svg>
            </div>
            <div className="navbar__logo-text">
              <span className="navbar__logo-name">Paradise</span>
              <span className="navbar__logo-tagline">Events</span>
            </div>
          </a>

          <div className="navbar__links-desktop">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="navbar__link"
                 onClick={(e) => handleClick(e, link.href)}>
                {link.label}
              </a>
            ))}
          </div>

          <a href="tel:+38349343079" className="navbar__cta-desktop">
            <span>Rezervo Tani</span>
          </a>

          <button
            className={`navbar__burger ${isOpen ? 'navbar__burger--open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="navbar__mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="navbar__mobile-bg" onClick={() => setIsOpen(false)} />
            <motion.div
              className="navbar__mobile-panel"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', damping: 30, stiffness: 300 }}
            >
              <div className="navbar__mobile-header">
                <span className="section-label" style={{ margin: 0 }}>Menu</span>
              </div>
              <div className="navbar__mobile-links">
                {navLinks.map((link, i) => (
                  <motion.a
                    key={link.href}
                    href={link.href}
                    className="navbar__mobile-link"
                    onClick={(e) => handleClick(e, link.href)}
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 + i * 0.06, duration: 0.4 }}
                  >
                    <span className="navbar__mobile-link-num">0{i + 1}</span>
                    <span className="navbar__mobile-link-label">{link.label}</span>
                  </motion.a>
                ))}
              </div>
              <div className="navbar__mobile-footer">
                <div className="gold-line" />
                <a href="tel:+38349343079" className="navbar__mobile-phone">
                  +383 49 343 079
                </a>
                <p className="navbar__mobile-address">
                  Rr. Enver Haradinaj, Pristina 10000
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
